<template>
  <div class="animated fadeIn">
    <b-row class="mt-3" >
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <i class="fa fa-pencil"></i> Sugerir {{templateName}}
          </div>
          <b-form-group>
            <p>Nossa equipe produz {{templateName}}s diariamente e você pode nos ajudar a decidir quais os temas da próxima semana. Teve uma ideia genial? Está faltando algo? Conta para a gente!</p>
          </b-form-group>
          <b-form-group>
            <textarea id="basicTextarea" v-model="text" class="form-control" :rows="5" :textarea="true" v-bind:placeholder="'Descreva o ' + templateName + ' que quer sugerir. Consultoria Online? Uma receita específica? Aqui quem manda é você!'"></textarea>
          </b-form-group>
          <b-form-group>
            <textarea id="basicTextarea" v-model="textSubtitle" class="form-control" :rows="10" :textarea="true" v-bind:placeholder="'Escreva um resumo do assunto. Quanto mais informações, mais rapidamente avaliaremos a sua sugestão! (Opcional)'"></textarea>
          </b-form-group>
          <b-form-group>
            <textarea id="basicTextarea" v-model="textSources" class="form-control" :rows="5" :textarea="true" v-bind:placeholder="'Sugira fontes de pesquisa. Nossa equipe só produz posts com fontes confiáveis; se você conhecer alguma que fale sobre o assunto, basta informar aqui. (Opcional)'"></textarea>
          </b-form-group>
          <div>
            <b-alert variant="danger" :show="errorMessage">{{errorMessage}}</b-alert>
          </div>
          <div>
            <b-alert variant="success" :show="success">{{templateName}} sugerido! Nossa equipe vai avaliar seu pedido e entrar em contato se for aprovado!</b-alert>
          </div>
          <b-row>
            <b-col sm="6">
              <p v-if="supportWhatsapp || supportWhatsapp">Ou entre em contato diretamente</p>
              <p v-if="supportWhatsapp">Whatsapp: <a v-bind:href="'https://api.whatsapp.com/send?phone=' + supportWhatsapp" target="_blank">{{supportWhatsapp}}</a></p>
              <p v-if="supportEmail">Email: <a v-bind:href="'mailto:' + supportEmail" target="_blank">{{supportEmail}}</a></p>
            </b-col>
            <b-col sm="6">
              <div class="text-right">
                <spinner v-show="openingTicket"></spinner>
                <b-button @click="openTicket" :disabled="!text" v-show="!openingTicket" variant="primary">
                  <i class="fa fa-pencil"></i> Sugerir {{templateName}} Agora
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import Spinner from "./Spinner";
import service from "../service";

export default {
  name: 'Support',
  data () {
    return {
      me: undefined,
      isMobileScreen: isMobile,
      errorMessage: undefined,
      text: "",
      openingTicket: false,
      success: false,
      textSources: "",
      textSubtitle: ""
    }
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    youtubeTutorial() {
      return localStorage.youtubeTutorial;
    },
    supportEmail() {
      return localStorage.supportEmail;
    },
    supportWhatsapp() {
      return localStorage.supportWhatsapp;
    }
  },
  methods: {
    openTicket() {
      this.openingTicket = true;

      let finalText = "<b>Pedido: </b></br>" + this.text;

      if (this.textSubtitle) {
        finalText += "<br/><br/><b>Resumo: </b></br>" + this.textSubtitle
      }

      if (this.textSources) {
        finalText += "<br/><br/><b>Fontes: </b></br>" + this.textSources
      }

      service.requestSleeker(finalText).then(() => {
        this.openingTicket = false;
        this.text = "";
        this.textSources = "";
        this.textSubtitle = "";
        this.success = true;
      }).catch((error) => {
        this.openingTicket = false;
        if (error && error.message) {
          this.errorMessage = error.message;
        } else {
          this.errorMessage = "Ocorreu um erro inesperado ao criar o ticket. Por favor, entre em contato por outra forma de suporte.";
        }
      });
    }
  },
  components: { Spinner },
  created() {
    
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
</style>
